import React from "react";

import CommonTable from "../../../../../common/CommonTable";
import GAClassroomAudioReactionsTableRow from "../GAClassroomAudioReactionsTableRow/GAClassroomAudioReactionsTableRow";

const headCells = [
  {
    id: "className",
    numeric: false,
    disablePadding: true,
    label: "Class Name",
    width: 180,
  },
  {
    id: "activityName",
    numeric: false,
    disablePadding: true,
    label: "Activity Name",
    width: 180,
  },
  {
    id: "reactionTo",
    numeric: false,
    disablePadding: true,
    label: "Reaction To",
    width: 120,
  },
  {
    id: "quicktaleTitle",
    numeric: false,
    disablePadding: true,
    label: "QuickTale Title",
    width: 180,
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Create Date",
    width: 170,
  },
  {
    id: "submittedBy",
    numeric: false,
    disablePadding: true,
    label: "Submitted By",
    width: 160,
  },
  {
    id: "processedAudioUrl",
    numeric: false,
    disablePadding: true,
    label: "Processed Audio",
    width: 120,
  },
  {
    id: "audioLength",
    numeric: true,
    disablePadding: true,
    label: "Length (s)",
    width: 100,
  },
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "Reaction ID",
    width: 260,
  },
];

const GAClassroomAudioReactionsTable = ({ rows }) => {
  return (
    <CommonTable
      selected={[]}
      setSelected={() => {}}
      tableData={rows || []}
      setTableData={() => {}}
      CommonTableRow={GAClassroomAudioReactionsTableRow}
      tableHeadData={headCells}
      showPosition={false}
      initialOrder="asc"
      initialOrderBy="createdAt"
    />
  );
};

export default GAClassroomAudioReactionsTable;
